<template>
  <div id="studentInfo">
    <sideBar />

    <div class="content-body-container col-md-8" :class="checkMobileStatus ? 'mobile-view' : 'web-view'">
      <div class="student-parent-info-container" v-if="checkMobileStatus">
        <div class="student-parent-info-header">
          <label>{{ lang('Parent').toUpperCase() }}{{ lang('Information').toUpperCase() }}</label>
        </div>

        <div class="student-parent-info-content">
          <div class="parent-content">
            <span> {{ lang('Father') }} : {{ parentInfo.FatherFirstName }} {{ parentInfo.FatherMiddleName }} {{ parentInfo.FatherLastName }} </span>
            <span> {{ lang('Mother') }} : {{ parentInfo.MotherFirstName }} {{ parentInfo.MotherMiddleName }} {{ parentInfo.MotherLastName }} </span>
          </div>

          <div class="parent-action">
            <a href="/MyAccount">
              <button class="btn btn-primary">
                <i class="fa fa-pencil"></i><span>{{ lang('Edit') }}</span>
              </button>
            </a>
          </div>
        </div>
      </div>

      <div class="student-parent-info-container" v-else>
        <div class="student-parent-info-left">
          <small>{{ lang('Parent') }}: </small>
          <h3 class="student-parent-name">{{ parentInfo.FatherFirstName }} {{ parentInfo.FatherMiddleName }} {{ parentInfo.FatherLastName }}</h3>
        </div>

        <!--                <div class="student-parent-info-right">-->
        <!--                    <small>Last Update: 20-02-2020</small>-->
        <!--                </div>-->

        <hr />
      </div>

      <div class="student-info-list-container">
        <div class="student-info-header">
          <label>{{ lang('Student Information').toUpperCase() }}</label>
        </div>

        <div class="student-info-content" v-for="student in studentsInfo">
          <div class="student-content">
            <label>{{ student.StudentFirstName + ' ' + student.StudentMiddleName + ' ' + student.StudentLastName }}</label>

            <div class="student-action" v-if="!checkMobileStatus">
              <span @click="editChild(student.StudentID)">
                <i class="fa fa-pencil"></i>
              </span>
            </div>

            <div class="student-content-details">
              <small
                ><span class="common-color-label">{{ lang('CLevel') }}</span> : <span class="common-block-label">{{ student.StudentLevel }}</span></small
              >
              <small
                ><span class="common-color-label">{{ lang('Class') }}</span> : <span class="common-block-label">{{ student.StudentClass }}</span></small
              >
              <small
                ><span class="common-color-label">{{ lang('School') }}</span> : <span class="common-block-label">{{ student.StudentSchool }}</span></small
              >
            </div>
          </div>

          <div class="student-action" v-if="checkMobileStatus">
            <button class="btn btn-primary col-md-12" @click="editChild(student.StudentID)" style="font-size: 12px">
              <i class="fa fa-pencil"></i><span>{{ lang('Edit') }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataSource from '../data/datasource'

import sideBar from '../components/Sidebar'
import Cookies from 'js-cookie'
import $ from 'jquery'
import { lang } from '../locale/index'

export default {
  name: 'NewStudentInfo',
  components: {
    sideBar,
  },
  data() {
    return {
      parentInfo: [],
      studentsInfo: [],

      checkMobileStatus: false,
    }
  },
  created() {
    if (Cookies.get('userTypeSession') === 'Parent') {
      this.LoadParentInfo()
      // this.LoadProfileImg();
    }

    window.addEventListener('resize', this.isMobile)
  },
  destroyed() {
    $(window).unbind('scroll')
    window.removeEventListener('resize', this.isMobile)
  },
  methods: {
    lang,
    async LoadParentInfo() {
      this.$vs.loading()
      try {
        if (Cookies.get('userIDSession') !== null || Cookies.get('userIDSession') !== undefined) {
          const response = await DataSource.shared.getParentStudentsInfo(Cookies.get('userIDSession'))
          if (response) {
            if (response.code === '2') {
              this.$notify.error({
                title: 'Error',
                message: 'No record found',
              })
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Please try again later',
              })
            } else {
              this.parentInfo = response.Parent[0]
              this.studentsInfo = response.Students

              this.$vs.loading.close()
            }
          }
        }
      } catch (e) {
        this.results = e
      }
    },
    editChild(studentID) {
      //window.location.replace('/MyChild?id=' + row.Student_ID);

      this.$router.push({
        name: 'My Child',
        params: {
          studentID: studentID,
        },
      })
    },

    isMobile() {
      let screenWidth = window.innerWidth
      if (screenWidth <= 770) {
        this.checkMobileStatus = true
        // return true;
      } else {
        this.checkMobileStatus = false
        // return false;
      }
    },
  },
  mounted() {
    const self = this
    // self.forceRerender();
    self.isMobile()

    window.history.scrollRestoration = 'manual'

    $(document).ready(function () {
      // $(".content-body-container").css("min-height", window.outerHeight);
      // $(".student-parent-info-container").appendTo(".sidebar-action-container .action-body");
    })
  },
}
</script>

<style scoped>
.content-body-container {
  display: inline-block;
  padding: 20px;
  /*background: white;*/
}

/* Web Css */
.web-view .student-parent-info-container {
  text-align: left;
}

.web-view .student-parent-info-left {
  display: inline-block;
}

.web-view .student-parent-info-left > small {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;

  color: #828894;
}

.web-view .student-parent-info-left .student-parent-name {
  display: inline-block;
  vertical-align: middle;
  margin: 0px;

  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  line-height: 28px;
}

.web-view .student-parent-info-right {
  float: right;
}

.web-view .student-parent-info-right > small {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;

  color: #828894;
}

.web-view .student-info-list-container {
  text-align: left;
}

.web-view .student-info-header > label {
  font-family: Neue Haas Grotesk Text Pro;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 22px;
  margin-bottom: 20px;
}

.web-view .student-info-content {
  width: 250px;
  /*border: 1px solid black;*/
  border-radius: 8px;
  margin: 0px 15px 20px 0px;
  display: inline-block;
}

.web-view .student-content {
  position: relative;
}

.web-view .student-content > label {
  padding: 10px 20px;
  background: #426dff;
  color: white;
  border-radius: 5px 5px 0px 0px;
  margin: 0px;

  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
}

.web-view .student-content-details {
  text-align: left;
  padding: 5px 20px;
  background: #ffffff;
  border-radius: 5px;
}

.web-view .student-content-details .common-color-label {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;

  color: #91a3b6;
}

.web-view .student-content-details .common-block-label {
  display: block;
  font-weight: bold;
  margin-bottom: 10px;

  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 16px;
}

.web-view .student-action {
  position: absolute;
  width: 30px;
  height: 30px;
  top: 5px;
  right: 0px;
  color: white;
  text-align: center;
  cursor: pointer;
}

.web-view .student-action > span {
  font-size: 12px;
  vertical-align: sub;
}

/*  Mobile Css  */
.mobile-view .student-parent-info-container {
  margin-bottom: 30px;
}

.mobile-view .student-parent-info-header > label,
.mobile-view .student-info-header > label,
.mobile-view .student-content-details > small > span {
  color: #acb3c0;
}

.mobile-view .student-parent-info-content {
  text-align: left;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  position: relative;
}

.mobile-view .parent-content,
.mobile-view .student-content {
  max-width: 80%;
}

.mobile-view .parent-content > span {
  display: block;
  color: #acb3c0;
  font-size: 12px;
}

.mobile-view .parent-action,
.mobile-view .student-action {
  position: absolute;
  top: 10px;
  right: 0px;
}

.mobile-view .parent-action > a > button,
.mobile-view .student-action > button {
  font-size: 12px;
  margin: 0px;
  padding: 2px 10px;
  border-radius: 4px 0px 0px 4px;
  /*min-width: 100%;*/
}

.mobile-view .parent-action > a > button > span,
.mobile-view .student-action > button > span {
  display: inline-block;
  margin-left: 5px;
}

.mobile-view .student-info-list-container {
  margin-bottom: 20px;
}

.mobile-view .student-info-content {
  position: relative;
  text-align: left;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 15px;
}

.mobile-view .student-content-details > small {
  display: block;
  margin-bottom: 5px;
  /*font-size: 12px;*/
}

@media (max-width: 769px) {
  .mobile-view .parent-action > a > button,
  .mobile-view .student-action > button {
    font-size: 12px;
    margin: 0px;
    padding: 2px 10px;
    border-radius: 4px 0px 0px 4px;
    min-width: auto;
  }
}

@media (max-width: 450px) {
  .mobile-view .parent-action > a > button,
  .mobile-view .student-action > button {
    font-size: 12px;
    margin: 0px;
    padding: 2px 10px;
    border-radius: 4px 0px 0px 4px;
    min-width: auto;
  }
}
</style>
